<script>
</script>

<div class="container">
  <a href="https://superwall.com">
    <div class="nav left">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        ><title>home-2</title><g fill="currentColor"
          ><path
            fill="currentColor"
            d="M11,16h2c0.6,0,1-0.4,1-1V8h1v0c0.3,0,0.6-0.1,0.8-0.3c0.4-0.4,0.3-1-0.1-1.4l-7-6c-0.4-0.3-0.9-0.3-1.3,0 l-7,6c-0.4,0.4-0.5,1-0.1,1.4C0.4,7.9,0.7,8,1,8c0.2,0,1,0,1,0v7c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1v-3h4v3C10,15.6,10.4,16,11,16z"
          /></g
        ></svg
      >
    </div>
  </a>
  <a href="https://superwall.com">
    <img
      src="https://templates.superwall.com/Superwall.svg"
      alt="logo"
    />
  </a>
  <a class="nav right" href="https://75v4gfh4e3l.typeform.com/to/Ghxiy9U1"
    ><span class="hidden-sm">Request a template</span><span class="hidden-lg"
      >Request</span
    >
  </a>
</div>

<style>
  .container {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 50;
    align-items: center;
    justify-content: center;
    background-color: #171819;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    width: 100%;
    height: 75px;
  }

  a {
    margin: 0px;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
  }

  img {
    width: 114px;
  }

  .nav {
    position: absolute;
    top: 15px;
    height: calc(100% - 30px);
    padding: 0px 20px;
    background-color: #75fff1;
    color: black;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 8px;
  }

  .nav.right {
    right: 15px;
  }

  .nav.left {
    left: 0px;
    width: 75px;
    top: 0px;
    height: 74px;
    border-radius: 0px;
    background-color: rgba(0, 0, 0, 0);
    border-right: 1px solid rgba(255, 255, 255, 0.07);
    padding: 0;
    color: #75fff1;
  }

  .hidden-lg {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .nav.right {
      font-size: 1rem;
      padding: 0;
      padding-left: 20px;
      padding-right: 20px;
      right: 0px;
      border-radius: 0px;
      top: 0px;
      color: #75fff1;
      background-color: rgba(0, 0, 0, 0);
      border-left: 1px solid rgba(255, 255, 255, 0.07);
      height: 74px;
    }

    .hidden-sm {
      display: none;
    }

    .hidden-lg {
      display: initial;
    }
  }
</style>
